import { useCallback, useMemo } from "react";

import { useLocalization } from "@fluent/react";

import {
  LIVE_LEDGER_TYPE_QUERY_KEY,
  TYPE_FILTER_OPTIONS,
} from "../../constants";
import { useSingleSelectFilter } from "../../hooks/useSingleSelectFilter";

import RadioButtonsFilterPanel from "./RadioButtonsFilterPanel";

export interface TypeFilterPanelProps {
  close: () => void;
  remove: () => void;
  onApply: () => void;
}

const VALID_VALUES = TYPE_FILTER_OPTIONS.map((option) => option.value);

const TypeFilterPanel = ({ close, remove, onApply }: TypeFilterPanelProps) => {
  const { l10n } = useLocalization();

  const options = useMemo(
    () =>
      TYPE_FILTER_OPTIONS.map((option) => ({
        value: option.value,
        label: l10n.getString(option.ftlKey),
      })),
    [l10n]
  );

  const getOptionLabel = useCallback(
    (value: string) => {
      const option = TYPE_FILTER_OPTIONS.find((o) => o.value === value);
      return option ? l10n.getString(option.ftlKey) : undefined;
    },
    [l10n]
  );

  const { selectedValue, setSelectedValue } = useSingleSelectFilter({
    queryKey: LIVE_LEDGER_TYPE_QUERY_KEY,
    validValues: VALID_VALUES,
    getOptionLabel,
  });

  return (
    <RadioButtonsFilterPanel
      options={options}
      selectedValue={selectedValue}
      setSelectedValue={setSelectedValue}
      close={close}
      remove={remove}
      onApply={onApply}
      applyLabel={l10n.getString("live-ledger-filter-type-apply")}
      removeLabel={l10n.getString("live-ledger-filter-type-remove")}
      testIdPrefix="ledger-type-filter"
    />
  );
};

export default TypeFilterPanel;
